import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  DocumentType,
  CreateDocumentTypeRequest,
  UpdateDocumentTypeRequest,
  ListDocumentTypesQuery,
  DocumentTypeReduced,
} from './DocumentTypes.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/document-types`;

export async function listDocumentTypes(
  params?: ListDocumentTypesQuery,
): Promise<PageResult<DocumentType>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<DocumentType>;
}

export async function listDocumentTypesReduced(
  params?: ListDocumentTypesQuery,
): Promise<PageResult<DocumentTypeReduced>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/reduced`,
    params,
  )) as unknown;

  return result as PageResult<DocumentTypeReduced>;
}

export async function getDocumentType(id: number): Promise<DocumentType> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as DocumentType;
}

export async function getDocumentTypeReduced(
  id: number,
): Promise<DocumentTypeReduced> {
  const result = (await api.get(
    `${CONTROLLER_URL}/${id}/reduced`,
    null,
  )) as unknown;

  return result as DocumentTypeReduced;
}

export async function createDocumentType(
  obj: CreateDocumentTypeRequest,
): Promise<DocumentType> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as DocumentType;
}

export async function updateDocumentType(
  obj: UpdateDocumentTypeRequest,
): Promise<DocumentType> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result as DocumentType;
}

export async function activeDocumentType(id: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${id}/active`,
    {},
    null,
  )) as unknown;

  return result as void;
}

export async function deleteDocumentType(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}
